/* eslint-disable */
import { SubmitHandler } from 'react-hook-form'

import { CreateAcademicOfferingPayload } from '@/types/forms/CreateAcademicOfferingPayload'
import {
    AcademicAdmission,
    AcademicCycleWithInitialDate
} from '@/types/forms/academicAdmission'
import { DateParser } from '@/utils/dateParser'
import { saveStudyModality } from '@/utils/studyModalityHelper'


// Helper to check if user has a category selection
const hasUserCategorySelection = (finalData: any): boolean => {
    return finalData.categoriaAdmision && finalData.categoriaAdmision !== ''
}

// Helper for loading category data
const loadCategoryData = async (
    inscriptionsApi: any,
    idInscription: number,
    finalData: any
): Promise<void> => {
    try {
        console.log('🌐 Cargando categoría para inscripción:', idInscription)
        console.log(
            '🔍 Estado inicial de finalData.categoriaAdmision:',
            finalData.categoriaAdmision
        )

        const categoryResponse =
            await inscriptionsApi.getCategoryByInscription(idInscription)

        console.log('📥 Respuesta completa de categoría:', {
            status: categoryResponse.status,
            data: categoryResponse.data,
            response: categoryResponse
        })

        if (categoryResponse.status === 200 && categoryResponse.data) {
            // El endpoint devuelve {id: number, name: string}
            const categoryId = categoryResponse.data.id
            const categoryName = categoryResponse.data.name

            // El dropdown espera formato con ceros a la izquierda (ej: "03")
            const categoryValue =
                categoryId < 10 ? `0${categoryId}` : categoryId.toString()

            finalData.categoriaAdmision = categoryValue

            console.log('✅ Categoría cargada exitosamente:', {
                originalId: categoryId,
                formattedValue: categoryValue,
                name: categoryName,
                finalDataAfter: finalData.categoriaAdmision
            })
        } else {
            console.log('⚠️ Respuesta de categoría no válida:', {
                status: categoryResponse.status,
                hasData: !!categoryResponse.data,
                data: categoryResponse.data
            })
            // Establecer "No Aplica" cuando no hay categoría válida
            finalData.categoriaAdmision = ''
            console.log('✅ Estableciendo "No Aplica" por respuesta no válida')
        }
    } catch (categoryError) {
        console.log(
            '❌ Error al cargar categoría (404 - No hay categoría asignada):',
            categoryError
        )

        // Establecer "No Aplica" cuando hay error 404
        finalData.categoriaAdmision = ''
        console.log('✅ Estableciendo "No Aplica" por error 404')
    }
}


// Helper for loading existing data
export const createLoadExistingData = (
    showLoader: () => void,
    hideLoader: () => void,
    aspirantsApi: any,
    inscriptionsApi: any,
    idAspirant: string,
    idInscription: number | null,
    reset: (data: any) => void,
    setHasExistingData: (value: boolean) => void,
    setHasLoadedExistingData: (value: boolean) => void,
    updateStudyModality?: (studyModality: string) => void
) => {
    return async () => {
        showLoader()
        try {
            console.log(
                '🔄 Iniciando carga de datos académicos para idAspirant:',
                idAspirant,
                'idInscription:',
                idInscription
            )
            const { data, status } = await aspirantsApi.getAcademicAdmission(
                idAspirant,
                idInscription
            )

            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
            console.log('📡 Respuesta del API getAcademicAdmission')
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
            console.log('Status:', status)
            console.log('Data completa:', JSON.stringify(data, null, 2))
            console.log('studyModality específico:', data?.studyModality)
            console.log('Tipo de studyModality:', typeof data?.studyModality)
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')

            const hasRealData =
                data &&
                Object.values(data).some(
                    (value) =>
                        value !== null && value !== undefined && value !== ''
                )

            if (status === 200 && hasRealData) {
                let finalData = { ...data }

                console.log('🔍 Debug - Datos cargados:', {
                    idInscription,
                    'data.studyModality': data.studyModality,
                    hasRealData
                })

                // Guardar studyModality usando helper centralizado
                saveStudyModality(
                    data.studyModality,
                    updateStudyModality,
                    'AcademicAdmission-Load'
                )

                
                // Si tenemos idInscription, cargar también la categoría
                // Siempre intentar cargar la categoría del backend para obtener el estado actual
                /* if (!idInscription) {
                    console.log('⚠️ idInscription no disponible')
                } else {
                    console.log(
                        '🔄 Cargando categoría del backend para verificar estado actual'
                    )
                    await loadCategoryData(
                        inscriptionsApi,
                        idInscription,
                        finalData
                    )
                } */
                reset(finalData)
                setHasExistingData(true)
            } else {
                setHasExistingData(false)
            }
        } catch (error) {
            setHasExistingData(false)
        } finally {
            setHasLoadedExistingData(true)
            hideLoader()
        }
    }
}

// Helper for submit success
export const createHandleSubmitSuccess = (
    updateIdInscription: (id: number) => void,
    aspirantsApi: any,
    idAspirant: string,
    idAsesor: number,
    clearPreloadData: () => void,
    onNext: () => void,
    updateStudyModality?: (studyModality: string) => void
) => {
    return async (data: AcademicAdmission, idInscription: string) => {
        console.log('📤 Enviando datos académicos:', {
            idAspirant,
            idInscription,
            idAsesor,
            categoriaAdmision: data.categoriaAdmision,
            studyModality: data.studyModality,
            educationModality: data.educationModality,
            fullData: data
        })

        // Validate that educationModality is set
        if (!data.educationModality || data.educationModality === '') {
            console.warn('⚠️ educationModality está vacío antes de enviar')
        }

        updateIdInscription(Number(idInscription))

        // Guardar studyModality usando helper centralizado
        saveStudyModality(
            data.studyModality,
            updateStudyModality,
            'AcademicAdmission-Submit'
        )

        const response = await aspirantsApi.postAcademicData(
            idAspirant,
            data,
            idInscription,
            idAsesor || 0
        )

        console.log('📥 Respuesta del servidor:', response)

        if (response.status === 200 || response.status === 201) {
            clearPreloadData()

            try {
                await aspirantsApi.sendAdmissionContinueEmail(
                    idInscription,
                    Number(data.admissionType)
                )
            } catch (error) {
                console.error('❌ Error enviando email de continuación:', error)
            }

            return onNext()
        }

        throw new Error(
            `Error al guardar los datos académicos: ${response.status}`
        )
    }
}

/**
 * Helper function to set educationModality from API
 * Validates required fields and fetches modality data
 */
const setEducationModality = async (
    data: AcademicAdmission,
    fetchModality: (
        programId: string,
        admissionTypeId: string,
        jornadaId: string
    ) => Promise<any>
): Promise<void> => {
    // Validate required fields
    if (!data.program || !data.admissionType || !data.studyModality) {
        console.warn(
            '⚠️ No se puede establecer educationModality: faltan datos requeridos',
            {
                program: data.program,
                admissionType: data.admissionType,
                studyModality: data.studyModality
            }
        )

        return
    }

    try {
        const education_modality = await fetchModality(
            data.program,
            data.admissionType,
            data.studyModality
        )

        if (education_modality?.modalityId) {
            data.educationModality = education_modality.modalityId.toString()
            console.log(
                '✅ educationModality establecido:',
                data.educationModality
            )
        } else {
            console.warn('⚠️ No se pudo obtener educationModality del API', {
                response: education_modality
            })
            // No lanzar error, solo loggear - el campo puede quedar vacío si el API no responde
        }
    } catch (error) {
        console.error('❌ Error al obtener educationModality:', error)
        // No lanzar error para no bloquear el flujo, pero loggear para debugging
    }
}

/**
 * Helper function to format date to YYYY-MM-DD format (ISO 8601)
 * Accepts various date formats and converts them to YYYY-MM-DD
 */
const formatDateToISO = (dateString: string): string => {
    if (!dateString) {
        return dateString
    }

    try {
        const parsedDate = DateParser.parseDate(dateString)
        if (parsedDate) {
            return DateParser.formatDate(parsedDate)
        }

        return dateString
    } catch (error) {
        console.error('❌ Error al formatear fecha:', error, dateString)

        return dateString // Retornar original en caso de error
    }
}

/**
 * Validates required fields for academic offering payload
 */
const validateAcademicOfferingFields = (data: AcademicAdmission): boolean => {
    return !!(
        data.program &&
        data.educationModality &&
        data.admissionType &&
        data.campus &&
        data.studyModality &&
        data.startPeriod
    )
}

/**
 * Finds the selected academic cycle from list
 */
const findSelectedCycle = (
    academicCycles: AcademicCycleWithInitialDate[],
    startPeriod: string
): AcademicCycleWithInitialDate | null => {
    const selectedCycle = academicCycles.find(
        (cycle) => String(cycle.cycleId) === String(startPeriod)
    )

    if (!selectedCycle) {
        console.warn('⚠️ No se encontró el ciclo académico seleccionado')
        console.warn('Ciclo buscado:', startPeriod)
        console.warn(
            'Ciclos disponibles:',
            academicCycles.map((c) => ({
                cycleId: c.cycleId,
                cycleName: c.cycleName
            }))
        )
    }

    return selectedCycle || null
}

/**
 * Extracts year and period from cycle data
 */
const extractYearAndPeriod = (
    formattedInitialDate: string,
    cycleName: string
): { year: number; period?: number } => {
    let year = NaN
    if (formattedInitialDate) {
        const match = formattedInitialDate.match(/^(\d{4})/)
        if (match) {
            year = parseInt(match[1], 10)
        }
    }

    if (isNaN(year)) {
        const dateObj = new Date(formattedInitialDate)
        year = dateObj.getFullYear()
    }

    let period: number | undefined = undefined

    // Intenta primero el formato SAP "2026 012 Semestre 2": el período (Perid) va después
    // del año y manda sobre el texto del ciclo (doctorados: 012 aunque el ciclo diga "Semestre 2")
    const formatMatch = cycleName.match(/^\d{4}\s+(\d{3})\s+/i)

    if (formatMatch) {
        period = parseInt(formatMatch[1], 10)
    } else {
        // Formato tradicional: "Semestre 1", "Periodo 2"
        const periodMatch = cycleName.match(/(?:semestre|periodo)\s*(\d+)/i)

        if (periodMatch) {
            period = parseInt(periodMatch[1], 10)
        } else {
            // Último intento: buscar cualquier número de 2-3 dígitos después del año
            const fallbackMatch = cycleName.match(/^\d{4}\s+(\d{2,3})/i)

            if (fallbackMatch) {
                period = parseInt(fallbackMatch[1], 10)
            }
        }
    }

    console.log('period', period)
    console.log('cycleName', cycleName)
    console.log('formatMatch', formatMatch)

    return { year, period }
}

/**
 * Helper function to build CreateAcademicOfferingPayload from AcademicAdmission data
 */
const buildAcademicOfferingPayload = async (
    data: AcademicAdmission,
    resourcesApi: any,
    fetchAcademicCycle: (
        programId: number,
        admissionTypeId: string,
        headquarterId: number,
        jornadaId: number
    ) => Promise<AcademicCycleWithInitialDate[] | undefined>
): Promise<CreateAcademicOfferingPayload | null> => {
    if (!validateAcademicOfferingFields(data)) {
        return null
    }

    try {
        const academicCycles = await fetchAcademicCycle(
            Number(data.program),
            data.admissionType,
            Number(data.campus),
            Number(data.studyModality)
        )

        if (!academicCycles || academicCycles.length === 0) {
            console.warn('⚠️ No se encontraron ciclos académicos')

            return null
        }

        console.log('📥 Ciclos académicos recibidos:', academicCycles)

        const selectedCycle = findSelectedCycle(
            academicCycles,
            data.startPeriod
        )

        if (!selectedCycle) {
            return null
        }

        console.log('✅ Ciclo seleccionado encontrado:', selectedCycle)
        console.log('📅 initialDate original:', selectedCycle.initialDate)

        const formattedInitialDate = formatDateToISO(selectedCycle.initialDate)

        console.log('📅 initialDate formateado:', formattedInitialDate)

        const { year, period } = extractYearAndPeriod(
            formattedInitialDate,
            selectedCycle.cycleName
        )

        const formattedFinalDate = (selectedCycle as any).finalDate
            ? formatDateToISO((selectedCycle as any).finalDate)
            : undefined

        const payload: CreateAcademicOfferingPayload = {
            planId: Number(data.program),
            modalityId: Number(data.educationModality),
            claseOye: Number(data.admissionType),
            idHeadquarter: Number(data.campus),
            idJornada: Number(data.studyModality),
            idCycleR: Number(data.startPeriod),
            initialDate: formattedInitialDate,
            year: year,
            period: period,
            finalDate: formattedFinalDate,
            isActive: true
        }

        return payload
    } catch (error) {
        console.error(
            '❌ Error al construir payload de Academic Offering:',
            error
        )

        return null
    }
}

/**
 * Logs academic offering response details
 */
const logAcademicOfferingResponse = (response: any): void => {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
    console.log('📥 Respuesta completa de createOrGetAcademicOfferingId')
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
    console.log('Status:', response.status)
    console.log('Response.data:', response.data)
    console.log('Response.data?.id:', response.data?.id)
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
}

/**
 * Handles successful academic offering response
 */
const handleAcademicOfferingSuccess = (response: any): number | null => {
    const idAcademicOffering = response.data?.id

    if (response.status === 200) {
        console.log(
            '✅ Oferta académica ya existe - ID existente:',
            idAcademicOffering
        )
    } else if (response.status === 201) {
        console.log(
            '✅ Nueva oferta académica creada - ID nuevo:',
            idAcademicOffering
        )
    }

    if (!idAcademicOffering) {
        console.error('❌ ERROR: La respuesta no contiene un ID válido')

        return null
    }

    console.log('✅ Academic Offering ID obtenido:', idAcademicOffering)

    return idAcademicOffering
}

/**
 * Helper function to create or get academic offering ID
 */
const createOrGetAcademicOffering = async (
    data: AcademicAdmission,
    resourcesApi: any,
    fetchAcademicCycle: (
        programId: number,
        admissionTypeId: string,
        headquarterId: number,
        jornadaId: number
    ) => Promise<AcademicCycleWithInitialDate[] | undefined>
): Promise<number | null> => {
    try {
        const payload = await buildAcademicOfferingPayload(
            data,
            resourcesApi,
            fetchAcademicCycle
        )

        if (!payload) {
            console.warn(
                '⚠️ No se pudo construir el payload de Academic Offering'
            )

            return null
        }

        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
        console.log('🔍 Consultando/Creando Academic Offering')
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
        console.log('📤 Payload enviado:', JSON.stringify(payload, null, 2))

        const response =
            await resourcesApi.createOrGetAcademicOfferingId(payload)

        logAcademicOfferingResponse(response)

        if (response.status === 200 || response.status === 201) {
            return handleAcademicOfferingSuccess(response)
        }

        console.warn(
            '⚠️ Respuesta inesperada al crear/obtener Academic Offering:',
            {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        )

        return null
    } catch (error) {
        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
        console.error('❌ Error completo al crear/obtener Academic Offering')
        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
        console.error('Error:', error)

        if ((error as any)?.response) {
            console.error('Error response:', (error as any).response)
        }

        console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')

        return null
    }
}

// Helper function to extract boolean value from API response
const extractBooleanValue = (response: any): boolean | undefined => {
    // Caso 1: La respuesta es directamente un booleano
    if (typeof response === 'boolean') {
        return response
    }

    // Caso 2: La respuesta es un objeto ApiResponse
    if (response && typeof response === 'object' && 'data' in response) {
        const data = response.data

        if (typeof data === 'boolean') {
            return data
        }

        if (typeof data === 'string') {
            return data.toLowerCase() === 'true'
        }
    }

    return undefined
}

// Helper for creating inscription
const createInscriptionPayload = async (
    data: AcademicAdmission,
    fetchModality: any,
    idAsesor: number,
    idAcademicOffering: number | null,
    idAspirant: number,
    aspirantsApi: any
) => {
    // Ensure educationModality is set before creating payload
    await setEducationModality(data, fetchModality)
    const categoryId =
    data.categoriaAdmision && data.categoriaAdmision !== ''
        ? Number(data.categoriaAdmision)
        : null
    // Por defecto es 1
    let isClaseOyenteValid = 1

    // Si es tipo de ingreso "02" (transferencia interna), usar misma validación que "03"
    if (data.admissionType === '02' && idAspirant) {
        try {
            const response =
                await aspirantsApi.getisElegibleForDoubleProgram(idAspirant)
            const isEligible = extractBooleanValue(response)

            // Si NO es elegible (no se validó por integración), enviar 0
            if (isEligible === false) {
                isClaseOyenteValid = 0
            }
            // Si es elegible (true) o undefined, mantener 1
        } catch (error: any) {
            // Si hay error (excepto 404), asumir que no se validó por integración
            if (error?.response?.status !== 404) {
                isClaseOyenteValid = 0
            }
            // Si es 404, mantener 1 (no aplica validación)
        }
    }

    // Si es tipo de ingreso "04", validar por integración
    if (data.admissionType === '04' && idAspirant) {
        try {
            const response =
                await aspirantsApi.getisElegibleForGraduateToOtherProgram(
                    idAspirant
                )
            const isEligible = extractBooleanValue(response)

            // Si encuentra la validación (true), enviar 1
            // Si NO encuentra (false o undefined), enviar 0
            if (isEligible === true) {
                isClaseOyenteValid = 1
            } else {
                isClaseOyenteValid = 0
            }
        } catch (error: any) {
            // Si hay error, asumir que no se encontró validación, enviar 0
            isClaseOyenteValid = 0
        }
    }

    // 👇 NUEVA VARIABLE: isStatusRejectedValid
    // Solo se envía si rejected history es false (valor 1)
    // Si es true, no se envía el campo (undefined)
    const isStatusRejectedValid = (data as any).isStatusRejectedValid

    return {
        academicAdmission: data,
        aliadoId: null,
        categoryId: categoryId,
        idAsesor: idAsesor || 0,
        interviewStatus: 'UNASSESSED',
        idAcademicOffering: idAcademicOffering,
        isClaseOyenteValid: isClaseOyenteValid,
        ...(isStatusRejectedValid !== undefined && { isStatusRejectedValid })
    }
}


/**
 * Updates inscription category
 */
const updateCategory = async (
    inscriptionsApi: any,
    idInscription: number,
    categoryId: number | null
): Promise<void> => {
    const updateCategoryResponse =
        await inscriptionsApi.updateInscriptionCategory(
            idInscription,
            categoryId
        )

    console.log('📥 Respuesta actualización categoría:', updateCategoryResponse)

    if (
        updateCategoryResponse.status !== 200 &&
        updateCategoryResponse.status !== 201
    ) {
        throw new Error(
            `Error al actualizar categoría: ${updateCategoryResponse.status}`
        )
    }
}


/**
 * Updates inscription with academic offering ID
 */
const updateInscriptionWithAcademicOffering = async (
    inscriptionsApi: any,
    idInscription: number,
    idAcademicOffering: number
): Promise<void> => {
    console.log('🔍 Paso 3: Actualizando idAcademicOffering en la inscripción')

    const updateInscriptionResponse = await inscriptionsApi.updateInscription(
        idInscription.toString(),
        {
            idAcademicOffering,
            crmLead: 'CRM_DISABLED_TEMP'
        }
    )

    if (
        updateInscriptionResponse.status !== 200 &&
        updateInscriptionResponse.status !== 201
    ) {
        throw new Error(
            `Error al actualizar inscripción: ${updateInscriptionResponse.status}`
        )
    }
}

// Helper function to update inscription academic offering
const updateInscriptionAcademicOffering = async (
    inscriptionsApi: any,
    resourcesApi: any,
    idInscription: number,
    categoryId: number | null,
    data: AcademicAdmission,
    fetchModality: any,
    fetchAcademicCycle: (
        programId: number,
        admissionTypeId: string,
        headquarterId: number,
        jornadaId: number
    ) => Promise<AcademicCycleWithInitialDate[] | undefined>,
    handleSubmitSuccess: (
        data: AcademicAdmission,
        idInscription: string
    ) => Promise<void>
) => {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
    console.log('🔄 Iniciando actualización de inscripción')
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')

    await setEducationModality(data, fetchModality)

    console.log('🔍 Paso 1: Obteniendo/Creando Academic Offering ID')
    const idAcademicOffering = await createOrGetAcademicOffering(
        data,
        resourcesApi,
        fetchAcademicCycle
    )

    if (!idAcademicOffering) {
        throw new Error(
            'No se pudo obtener el Academic Offering ID. Por favor, verifica que todos los campos académicos estén completos.'
        )
    }

    console.log('✅ Academic Offering ID obtenido:', idAcademicOffering)

    try {
        console.log('🔍 Paso 2: Actualizando inscripción con academic offering')
        //await updateCategory(inscriptionsApi, idInscription, categoryId)
        await updateInscriptionWithAcademicOffering(
            inscriptionsApi,
            idInscription,
            idAcademicOffering
        )
        await handleSubmitSuccess(data, idInscription.toString())
    } catch (error) {
        console.error('❌ Error al actualizar inscripción:', error)
        throw error
    }
}

// Helper function to create new inscription
const createNewInscription = async (
    inscriptionsApi: any,
    resourcesApi: any,
    idAspirant: string,
    data: AcademicAdmission,
    fetchModality: any,
    fetchAcademicCycle: (
        programId: number,
        admissionTypeId: string,
        headquarterId: number,
        jornadaId: number
    ) => Promise<AcademicCycleWithInitialDate[] | undefined>,
    idAsesor: number,
    handleSubmitSuccess: (
        data: AcademicAdmission,
        idInscription: string
    ) => Promise<void>,
    aspirantsApi: any
) => {
    console.log('➕ Creando nueva inscripción')

    // Create or get academic offering ID first
    const idAcademicOffering = await createOrGetAcademicOffering(
        data,
        resourcesApi,
        fetchAcademicCycle
    )

    if (!idAcademicOffering) {
        console.warn('⚠️ No se pudo obtener el Academic Offering ID')
        // Decidir si continuar o lanzar error según los requisitos del negocio
        // Por ahora continuamos pero sin idAcademicOffering
    }

    const payload = await createInscriptionPayload(
        data,
        fetchModality,
        idAsesor,
        idAcademicOffering,
        Number(idAspirant),
        aspirantsApi
    )

    console.log('📦 Payload de creación:', payload)

    const inscriptionResponse = await inscriptionsApi.createInscription(
        idAspirant,
        payload
    )

    console.log('📥 Respuesta creación:', inscriptionResponse)

    if (
        inscriptionResponse.status === 200 ||
        inscriptionResponse.status === 201
    ) {
        const newIdInscription = inscriptionResponse.data.id.toString()

        if (newIdInscription) {
            await handleSubmitSuccess(data, newIdInscription)
        }
    }
}

// Helper for main submit (corregido para manejar inscripciones existentes)
export const createOnSubmit = (
    idAspirant: string,
    idInscription: number | null,
    hasExistingData: boolean,
    showLoader: () => void,
    hideLoader: () => void,
    fetchModality: any,
    fetchAcademicCycle: (
        programId: number,
        admissionTypeId: string,
        headquarterId: number,
        jornadaId: number
    ) => Promise<AcademicCycleWithInitialDate[] | undefined>,
    inscriptionsApi: any,
    resourcesApi: any,
    idAsesor: number,
    handleSubmitSuccess: (
        data: AcademicAdmission,
        idInscription: string
    ) => Promise<void>,
    aspirantsApi: any
): SubmitHandler<AcademicAdmission> => {
    return async (data) => {
        if (!idAspirant) {
            return
        }

        console.log('🚀 Iniciando envío:', {
            hasExistingData,
            idInscription,
            categoriaAdmision: data.categoriaAdmision,
            program: data.program,
            educationModality: data.educationModality
        })

        const categoryId =
                    data.categoriaAdmision && data.categoriaAdmision !== ''
                        ? Number(data.categoriaAdmision)
                        : null

        try {
            showLoader()

            if (hasExistingData && idInscription) {
                // ACTUALIZAR academic offering de la inscripción existente
                console.log(
                    '🔄 Actualizando academic offering de inscripción:',
                    idInscription
                )

                await updateInscriptionAcademicOffering(
                    inscriptionsApi,
                    resourcesApi,
                    idInscription,
                    categoryId,
                    data,
                    fetchModality,
                    fetchAcademicCycle,
                    handleSubmitSuccess
                )
            } else {
                // CREAR nueva inscripción
                await createNewInscription(
                    inscriptionsApi,
                    resourcesApi,
                    idAspirant,
                    data,
                    fetchModality,
                    fetchAcademicCycle,
                    idAsesor,
                    handleSubmitSuccess,
                    aspirantsApi
                )
            }
        } catch (error) {
            console.error('❌ Error completo:', error)
            throw error // Re-throw para que el componente pueda manejar el error
        } finally {
            hideLoader()
        }
    }
}
